import {
  Button,
  chakra,
  VStack,
  Container,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Heading,
  Stack,
  Image,
  Img,
  useMediaQuery,
  Center,
  Flex,
  HStack,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BottomNavBar from '../../../../BottomNavBar';
import Contact from '../../../../../images/ClinicoIcon.svg';

import BackButton from '../../../../../images/assets/telemedicina/backbutton.svg';
import TelemedDeslogado from '../../../../../images/Deslogado/telemedDeslogado.svg';
import Loading from '../../../../Loading';
import { AccountContext } from 'components/AccountContext';
import { api } from 'api/api';
import aviso from '../../../../../images/aviso.svg';
import { userIsSubscriber } from 'components/Utils/theme';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function ConferePedido() {
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
  const navigate = useNavigate();
  const { state } = useLocation();
  const arrName = state.medicoNome.split(' ');
  const [splitRules, setSplitRules] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { agenda } = state;
  const [pickWarning, setPickWarning] = useState(false);
  const { user } = useContext(AccountContext);
  const regraId = [55, 29];
  const plano_id = user.id_plano;
  // mandar cpf no lugar do paciente_id
  const lockAgenda = async (agendaId) => {
    try {
      const url = ENDPOINT + '/schedule/lockByAgendaExames/' + agendaId + '/' + state.paciente.cpf;
      const response = await api(url, {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        method: 'GET',
      });
      const postsData = await response.json();
    } catch (error) {
      console.log(error);
    }
  };

  const checkAvailability = async (agendaId) => {
    function formatDateTimeToISO(dateString, timeString) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month}-${day}T${timeString}:00`;
    }
    const url = ENDPOINT + '/schedule/checkAvailability/' + agendaId + '/' + state.idClientClinica;

    const response = await api(url, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      method: 'GET',
    });

    const postsData = await response.json().then(({ available }) => {
      if (available === true) {
        lockAgenda(state.agenda.AVAILABILITY_LID);
        if (!splitRules) {
          if (!state.valor || state.valor === 0 || state.valor === '0.00' || state.valor === '0') {
            const eventData = {
              title: state.procedimento,
              startDate: state.agenda.data_inicio,
              endDate: state.agenda.data_inicio,
              location: state.medico.dados.agenda_especialidade
                ? 'Atendimento Online'
                : `${state.clinica}  ${state.logradouro}, ${state.numero} - ${state.bairro} - ${state.municipio}`,
              notes: 'Certifique-se de entrar no app 15 minutos antes da sua consulta medica iniciar',
              agenda_exames_id: state.agenda.AVAILABILITY_LID,
            };

            navigate('/atendimento/loading/', {
              state: {
                modalidade: 'especialista online',
                valor: 0,
                paciente: state.paciente,
                agenda: state.agenda,
                medico: state.medico,
                orientacoes: state.orientacoes,
                confim: true,
                transaction_id: 9999999,
                procedimentoId: state.procedimentoId,
                procedimento: state.procedimento,
                product_name: state.agenda.ACTIVITY_NAME,
                paid: true,
                forma_pgto: 'DINHEIRO',
                eventData: eventData,
                triagem: true,
                valorExtraPsicologo: state?.valorExtraPsicologo,
                valor_extra_psicologo: state?.valor_extra_psicologo,
              },
            });
          } else {
            navigate('/pagamentos', {
              state: {
                modalidade: 'especialista online',
                parcelsActive: true,
                valor: state.valor,
                expiration_pix_in_min: 5,
                service: 'schedule',
                navig_to: '/alerts/sucesso/agendamento/',
                triagem: true,
                item: {
                  cpf: onlyNumbers(state.paciente.cpf),
                  nome: state.paciente.nome,
                  fone: state.paciente.celular ? state.paciente.celular : state.paciente.phone1,
                  email: state.paciente.email,
                  scheduleId: state.agenda.AVAILABILITY_LID,
                  procedimento_convenio_id: state.procedimentoId,
                  product_name: state.agenda.ACTIVITY_NAME,
                  confim: true,
                  orcamento_id: state.orcamento_id ? state.orcamento_id : null,
                  agenda_exames_id: state.agenda.AVAILABILITY_LID,
                  especialidade_id: state?.medico?.dados.ambulatorio_tipo_consulta_id,
                  medico_id: state?.medico?.dados?.medico_id,
                  modalidade: 'especialista online',
                  valorExtraPsicologo: state?.valorExtraPsicologo,
                  valor_extra_psicologo: state?.valor_extra_psicologo,
                },
                frequenciaText: 'Consulta telemedicina',
              },
            });
          }
        } else {
          navigate('/pagamentos', {
            state: {
              modalidade: 'especialista online',
              parcelsActive: true,
              valor: state.valor,
              split: splitRules.split_rules,
              expiration_pix_in_min: 5,
              service: 'schedule',
              triagem: true,
              navig_to: '/alerts/sucesso/agendamento/',
              item: {
                cpf: onlyNumbers(state.paciente.cpf),
                nome: state.paciente.nome,
                fone: state.paciente.celular ? state.paciente.celular : state.paciente.phone1,
                email: state.paciente.email,
                scheduleId: state.agenda.AVAILABILITY_LID,
                procedimento_convenio_id: state.procedimentoId,
                product_name: state.agenda.ACTIVITY_NAME,
                confim: true,
                orcamento_id: state.orcamento_id ? state.orcamento_id : null,
                especialidade_id: state?.medico?.dados.ambulatorio_tipo_consulta_id,
                medico_id: state?.medico?.dados?.medico_id,
                modalidade: 'especialista online',
                valorExtraPsicologo: state?.valorExtraPsicologo,
                valor_extra_psicologo: state?.valor_extra_psicologo,
              },
              frequenciaText: 'Consulta telemedicina',
            },
          });
        }
      } else {
        setPickWarning(true);
      }
    });
  };

  async function getSplitRules(agendaId) {
    try {
      const url = ENDPOINT + '/schedule/splitRules/' + agendaId + '/' + state.procedimentoId + '/';
      const options = {
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
      };
      const response = await api(url, options);
      const splitRules = await response.json();
      setSplitRules(splitRules);
      setLoading(false);
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  }

  useEffect(() => {
    if ((agenda?.split_pagamento || agenda?.split_pagamento_empresa) && state.valor !== 0 && state.valor !== '0.00' && state.valor !== '0') {
      getSplitRules(agenda.AVAILABILITY_LID);
    } else {
      setLoading(false);
    }
  }, []);
  const assinante = userIsSubscriber(user);
  const [telefonePequeno] = useMediaQuery('(max-height: 667px)');

  const atendimentoRestrito = state?.atendimentoRestrito;

  return loading ? (
    <Loading />
  ) : (
    <>
      <Modal isOpen={pickWarning} isCentered>
        <ModalOverlay />
        <ModalContent height="250px" width="300px" border-radius="1em">
          <ModalHeader></ModalHeader>

          <ModalBody>
            <VStack>
              <Heading size="md" textAlign="center" pl="5" pr="5" mt="15">
                Opa! O horário escolhido não está mais disponível.
              </Heading>
              <Stack direction="row" ml="-4" pt="1em" spacing={5} align="center">
                <Button
                  id="id_cpd_continuar"
                  backgroundColor={'#5AB2AE'}
                  color="#FFF"
                  variant="solid"
                  size="lg"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Continuar
                </Button>
              </Stack>
            </VStack>
          </ModalBody>

          <VStack ml="4"></VStack>
        </ModalContent>
      </Modal>
      <VStack
        position="relative"
        align="center"
        justify="flex-start"
        minH="100vh"
        spacing={4}
        background={assinante ? '#5AB2AE' : '#5AB2AE'}
        color="#585858"
        p={{ base: 2, sm: 4, md: 6 }}
        overflow="auto"
        mb={10}
      >
        <Flex w="100%" justify="flex-start" p={2}>
          <Image boxSize={{ base: '40px', sm: '40px' }} src={BackButton} cursor="pointer" onClick={() => navigate(-1)} />
        </Flex>

        <Box
          as="card"
          width={{ base: '90%', sm: '95%', md: '80%', lg: '70%' }}
          borderRadius="18px"
          fontSize={{ base: 'sm', sm: 'md' }}
          backgroundColor="white"
          p={{ base: 4, sm: 6 }}
          mb={{ base: '1em', sm: '2em' }}
          minH="70vh"
        >
          <Center>
            <Img src={assinante ? Contact : TelemedDeslogado} w="15%" />
          </Center>
          <chakra.h1 fontWeight="bold" margin="5% 0" fontSize="xl">
            Informações do Pedido:
          </chakra.h1>

          <VStack flex={1} align="flex-start" mb={4}>
            <HStack w="100%">
              <chakra.h1 color="gray.400">Profissional:</chakra.h1>
              <chakra.h1 color="gray.600">
                {' ' + arrName[0].toUpperCase()} {arrName[1]?.toUpperCase()}
              </chakra.h1>
            </HStack>

            <HStack w="100%">
              <chakra.h1 color="gray.400">Paciente:</chakra.h1>
              <chakra.h1 color="gray.600">{state.paciente.nome.toUpperCase()}</chakra.h1>
            </HStack>

            <chakra.h1 color="gray.400">
              Procedimento: <chakra.span color="gray.600">{state.procedimento}</chakra.span>
            </chakra.h1>

            <HStack w="100%">
              <chakra.h1 color="gray.400">Data: </chakra.h1>
              <chakra.h1 color="gray.600">
                {state.agenda.AVA_DATE}
                {' as '}
                {state.agenda.AVA_START_TIME}
              </chakra.h1>
            </HStack>

            <HStack w="100%">
              <chakra.h1 color="gray.400">Local: </chakra.h1>
              <chakra.h1 color="gray.600">
                {state.medico.dados.agenda_especialidade ? (
                  <chakra.h1 color="red.500" fontWeight="bold">
                    Atendimento Online
                  </chakra.h1>
                ) : (
                  <>
                    <chakra.h1 color="gray.600">{state.clinica}</chakra.h1>
                    <chakra.h1 color="gray.600">
                      {' '}
                      {state.logradouro}, {state.numero} - {state.bairro} - {state.municipio}
                    </chakra.h1>
                  </>
                )}
              </chakra.h1>
            </HStack>

            <HStack w="100%">
              <chakra.h1 color="gray.400"> Valor: </chakra.h1>
              <chakra.h1 color="gray.600">
                {parseFloat(state?.valor, 2)?.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}{' '}
                {state?.importante ? 'valor consulta extra' : ''}
              </chakra.h1>
            </HStack>
          </VStack>

          <Box align="left" borderRadius="0.8em" p={2} shadow="sm" bg={'#FAFAFA'} mt="5%" mb={2}>
            <HStack spacing={2} align="center" margin="5% 0">
              <chakra.h1  fontWeight="bold" fontSize="1em" color={'#616161'}>
                Orientações:
              </chakra.h1>
            </HStack>
            <chakra.p color="#616161" fontSize="sm">
              {!state.valor || state.valor === 0 || state.valor === '0.00' || state.valor === '0'
                ? 'Certifique-se de entrar no app 15 minutos antes da sua consulta medica iniciar'
                : 'O horário fica reservado por 30 minutos. Sem confirmação de pagamento, a vaga será liberada'}
            </chakra.p>
          </Box>

          {regraId.includes(plano_id) && (
            <>
              <Box align="left" borderRadius="0.8em" p={1} shadow="sm" bg={'#FFCBCF'}>
                <HStack spacing={2} align="center" margin="5% 0">
                  <img src={aviso} alt="Atenção!" />
                  <chakra.h1 ml={2} fontWeight="bold" fontSize="1em" color={'#D62422'}>
                    Atenção!
                  </chakra.h1>
                </HStack>
                <chakra.p color="#D62422" fontSize="sm">
                  Compareça ou cancele até 24h antes do atendimento. Falta sem aviso gera cobrança em até 30 dias.
                </chakra.p>
              </Box>
            </>
          )}

          <Center mt={3}>
            <Button
              backgroundColor={assinante ? '#5AB2AE' : '#5AB2AE'}
              width="100%"
              textColor="white"
              onClick={() => {
                checkAvailability(state.agenda.AVAILABILITY_LID);
              }}
            >
              Continuar
            </Button>
          </Center>
        </Box>
      </VStack>
      <BottomNavBar />
    </>
  );
}

export default ConferePedido;
